import { Injectable } from '@angular/core';
import { Router, CanActivateChild,ActivatedRouteSnapshot  } from '@angular/router';
import { SecurityService } from './security.service';
import { NotificationService } from './notification.service';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuardService implements CanActivateChild {
  constructor(private router: Router,private securityService: SecurityService,private notificationService: NotificationService, private errorService: ErrorService) { }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    const requiresFullAccess = route.data['requiresFullAccess'] ?? false;

    if (requiresFullAccess && this.securityService.isReadOnly()) {
        const message = this.errorService.getForbiddenAcessMessage();
        this.notificationService.showError(message);
        this.router.navigate(['']);
        return false;
    }
    return true;
  }
}